import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=bad5efc0&scoped=true&"
import script from "./index2.vue?vue&type=script&lang=ts&"
export * from "./index2.vue?vue&type=script&lang=ts&"
import style0 from "./index2.vue?vue&type=style&index=0&id=bad5efc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad5efc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
